import TransportsController from './transports.controller';

require('./transports.scss');

const TransportsComponent = {
    selector: 'sbTransports',
    controller: TransportsController,
    template: require('./transports-view.html'),
};

export default TransportsComponent;



// WEBPACK FOOTER //
// ./src/app/components/transports/index.js